import { SVGProps, Ref, forwardRef } from 'react';

export const IbsSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.74 8.451a.31.31 0 0 1 .308.307q0 .06-.025.117a.3.3 0 0 1-.167.165.3.3 0 0 1-.118.022l.002.001h-.614v-.612z"
                fill="currentColor"
            />
            <path d="M7.714 6.941a.3.3 0 0 1 .289.292.303.303 0 0 1-.293.295l-.586-.002v-.585z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5zM2.764 6.942h.341v2.116h-.341v.978h2.21v-.978h-.341V6.942h.342v-.978H2.764zm2.62.004h.343v2.112h-.343v.978h3.092a1.125 1.125 0 0 0 1.053-1.143 1.02 1.02 0 0 0-.69-.958l.005-.017a.95.95 0 0 0 .552-.93c0-.526-.409-1.02-1.117-1.02H5.384zm5.762-.978c-.792 0-1.413.467-1.414 1.263a1.225 1.225 0 0 0 1.263 1.226h.833a.307.307 0 0 1 .217.523.3.3 0 0 1-.217.09h-.614v-.3H9.945v1.266h2.31a1.275 1.275 0 0 0 1.272-1.268 1.25 1.25 0 0 0-.79-1.155 1.3 1.3 0 0 0-.485-.087l-.846.002a.3.3 0 0 1-.292-.295.293.293 0 0 1 .292-.292h.586v.287h1.259v-1.26z"
                fill="currentColor"
            />
        </g>
    </svg>
));
IbsSolidSize16Glyph.displayName = 'IbsSolidSize16Glyph';
